<template>
    <b-row class="rowbg">
 <!--       <b-col md="12">
            <b-card>
                <b-card-title>Bedrijfshow of Thuisbezoek</b-card-title>
                <b-card-text>
                   Ben je opzoek voor een bezoek van Sinterklaas en Piet bij jou thuis, klik dan  <b-link href="https://groteboek.ridderendeprins.nl/contact">hier</b-link>.
                </b-card-text>
                <b-card-text>
                    Ben je benieuwd wat de mogelijkheden zijn van een bezoek van Sinterklaas en de Pieten voor jouw bedrijf, klik dan <b-link to="/contact">hier</b-link>.
                </b-card-text>
                </b-card>
            </b-col>
        -->

       
   <b-col lg="6" class="pb-3">
       <b-card title="Thuisbezoek" tag="article">
        <b-card-text class="card-text-clamped">
            <!--Ben je opzoek voor een bezoek van Sinterklaas en Piet bij jou thuis, klik dan  <b-link href="https://groteboek.ridderendeprins.nl/contact">hier</b-link>
        -->            
            Ben je opzoek voor een bezoek van Sinterklaas en Piet bij jou thuis, boek hier je Huisbezoek.
       <br>
       <br>
        </b-card-text >
        <b-link href="https://groteboek.ridderendeprins.nl/contact" class="detaillink mt-auto">Huisbezoek</b-link>
      </b-card>
    </b-col>
  
    <b-col lg="6" class="pb-3">
        <b-card title="Bedrijfshow" tag="article">
            <b-card-text class="card-text-clamped">
               <!--Ben je benieuwd wat de mogelijkheden zijn van een bezoek van Sinterklaas en de Pieten voor jouw bedrijf, klik dan <b-link to="/contact">hier</b-link> of beneden.
            -->
               Ben je benieuwd wat de mogelijkheden zijn van een bezoek van Sinterklaas en de Pieten voor jou bedrijf, boek dan hier je Bedrijfsbezoek
            </b-card-text>
             <b-link to="/contact" class="detaillink" mt-auto>Bedrijfsbezoek</b-link>
      </b-card>
    </b-col> 

    </b-row>
</template>

<script>
    export default {
        name: 'Klantselectie'
    }
</script>

<style>

</style>